
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M160 80c-4.8 0-8 3.2-8 8s3.2 8 8 8h8c4.8 0 8-3.2 8-8s-3.2-8-8-8h-8zM192 80c-4.8 0-8 3.2-8 8s3.2 8 8 8h8c4.8 0 8-3.2 8-8s-3.2-8-8-8h-8zM128 96h8c4.8 0 8-3.2 8-8s-3.2-8-8-8h-8c-4.8 0-8 3.2-8 8s3.2 8 8 8zM312 448c-4.8 0-8 3.2-8 8s3.2 8 8 8h8c4.8 0 8-3.2 8-8s-3.2-8-8-8h-8zM344 448c-4.8 0-8 3.2-8 8s3.2 8 8 8h8c4.8 0 8-3.2 8-8s-3.2-8-8-8h-8zM280 448H128c-4.8 0-8 3.2-8 8s3.2 8 8 8h160c4.8 0 8-3.2 8-8s-3.2-8-8-8h-8z"}}),_c('path',{attrs:{"d":"M445.6 82.4l-80-80C364 .8 362.4 0 360 0H72c-4.8 0-8 3.2-8 8v496c0 4.8 3.2 8 8 8h368c4.8 0 8-3.2 8-8v-96c0-4.8-3.2-8-8-8s-8 4-8 8v88H80V16h272v72c0 4.8 3.2 8 8 8h72v256c0 4.8 3.2 8 8 8s8-4 8-8V88c0-2.4-.8-4-2.4-5.6zM368 80V28l52 52h-52z"}}),_c('path',{attrs:{"d":"M440 368c-4.8 0-8 3.2-8 8v8c0 4.8 3.2 8 8 8s8-3.2 8-8v-8c0-4.8-3.2-8-8-8zM240 56c0-4.8-3.2-8-8-8H128c-4.8 0-8 3.2-8 8s3.2 8 8 8h104c4.8 0 8-3.2 8-8zM128 128h104c4.8 0 8-3.2 8-8s-3.2-8-8-8H128c-4.8 0-8 3.2-8 8s3.2 8 8 8zM272.8 144.8c-2.4 0-4.8.8-6.4 1.6-1.6 1.6-2.4 4-2.4 5.6v120H128c-4.8 0-8 3.2-8 8 0 20.8 4.8 40.8 13.6 59.2C156.8 386.4 203.2 416 256 416c75.2 0 136-60.8 136-136 0-68.8-51.2-126.4-119.2-135.2zM256 400c-46.4 0-88-25.6-108-67.2-7.2-14.4-11.2-28.8-12-44.8h136c4.8 0 8-3.2 8-8V162.4c56 11.2 96 60 96 117.6 0 66.4-53.6 120-120 120z"}}),_c('path',{attrs:{"d":"M121.6 253.6c1.6 1.6 4 2.4 6.4 2.4h112c4.8 0 8-3.2 8-8v-96c0-2.4-.8-4-2.4-5.6-1.6-1.6-3.2-2.4-5.6-2.4-13.6 0-48.8 3.2-79.2 29.6-30.4 26.4-38.4 60-40.8 73.6 0 2.4 0 4.8 1.6 6.4zm49.6-68c21.6-19.2 46.4-24 60.8-25.6v80h-94.4c4-14.4 12-36 33.6-54.4z"}})])
          )
        }
      }
    